import { fetchPriorityListArtist, fetchUserIPv4, patchPriorityListUser, postPriorityListUser } from 'api/api'

import _ from 'lodash'
import { createFetcherThunk } from 'redux/thunkCreators'
import { createSelector } from 'reselect'
import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

export const initialState = {
    //Defaults
    artist: {
        name: 'Novel',
        artistImg: '',
        endTime: moment()
            .add(2, 'hours')
            .format(),
    },
    ipv4: '',
    isFormComplete: false,
    priorityListUser: null,
    creationError: null,
    refCode: null,
}

const priorityListSlice = createSlice({
    name: 'priorityList',
    initialState,
    reducers: {
        artistReceived: (state, { payload }) => ({ ...state, artist: payload }),
        updatePriorityListUserReceived: (state, { payload }) => ({
            ...state,
            priorityListUser: payload,
            isFormComplete: true,
        }),
        createPriorityListUserReceived: (state, { payload }) => ({ ...state, priorityListUser: payload }),
        failedPriorityListCreation: (state, { payload }) => ({ ...state, creationError: payload }),
        ipReceived: (state, { payload }) => ({ ...state, ipv4: payload }),
        setRefCode: (state, { payload }) => ({ ...state, refCode: payload }),
    },
})

const { actions, reducer } = priorityListSlice // Extract the action creators object and the reducer
export default reducer

//Selectors
export const getPriorityList = store => store.priorityList
export const getArtist = createSelector(getPriorityList, store => store.artist)
export const getGetPriorityListUser = createSelector(getPriorityList, store => store.priorityListUser)
export const getCreationError = createSelector(getPriorityList, store => store.creationError)
export const getIPv4 = createSelector(getPriorityList, store => store.ipv4)
export const getIsFormComplete = createSelector(getPriorityList, store => store.isFormComplete)
export const getRefCode = createSelector(getPriorityList, store => store.refCode)

//Action creators
export const {
    artistReceived,
    createPriorityListUserReceived,
    updatePriorityListUserReceived,
    failedPriorityListCreation,
    ipReceived,
    setRefCode,
} = actions

//Thunks
export const retrievePriorityListArtist = createFetcherThunk(fetchPriorityListArtist, null, artistReceived)

export const createPriorityListUser = (artistId, body) => async dispatch => {
    try {
        let user = _.get(await postPriorityListUser(artistId, body), 'data')
        dispatch(createPriorityListUserReceived(user))
    } catch (err) {
        let status = _.get(err, 'response.data.statusCode')
        if (status === 409) {
            dispatch(failedPriorityListCreation(`You're already on the priority list!`))
        } else {
            dispatch(failedPriorityListCreation(`Please check that your email is correct and try again`))
        }
    }
}

export const updatePriorityListUser = createFetcherThunk(patchPriorityListUser, null, updatePriorityListUserReceived)

export const retrieveUserIPv4 = createFetcherThunk(fetchUserIPv4, null, ipReceived)

export const setFriendRefCode = code => setRefCode(code)
